"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgJobStatisticsInkStorm = void 0;
const MsgJobStatistics_1 = require("./MsgJobStatistics");
class MsgJobStatisticsInkStorm extends MsgJobStatistics_1.MsgJobStatistics {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
exports.MsgJobStatisticsInkStorm = MsgJobStatisticsInkStorm;
